/**
 * Single source of truth for contact information.
 *
 * Previously, two different WhatsApp numbers were hard-coded across
 * the codebase (Footer used 0164409527, the floating button used
 * 0782939383). This file unifies them.
 *
 * If you need to change a number, change it ONLY here.
 */

// --- WhatsApp ---
// Mobile is preferred for B2B reactivity (instant notifications).
export const WHATSAPP_NUMBER = '33782939383'; // international format, no '+'
export const WHATSAPP_DISPLAY = '+33 7 82 93 93 83';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

/**
 * Build a pre-filled WhatsApp link with a custom message.
 * @param {string} message
 * @returns {string} wa.me URL
 */
export function buildWhatsAppLink(message = '') {
  if (!message) return WHATSAPP_URL;
  return `${WHATSAPP_URL}?text=${encodeURIComponent(message)}`;
}

// --- Phone (mobile - B2B preferred) ---
export const PHONE_NUMBER = '+33782939383';
export const PHONE_DISPLAY = '+33 7 82 93 93 83';
export const PHONE_URL = `tel:${PHONE_NUMBER}`;

// --- Email ---
export const CONTACT_EMAIL = 'contact@geots.consulting';
export const EMAIL_URL = `mailto:${CONTACT_EMAIL}`;

// --- Social ---
export const LINKEDIN_URL = 'https://www.linkedin.com/company/geots-consulting/';

// --- Address ---
export const COMPANY_ADDRESS = {
  city: 'Combs-la-Ville (77)',
  country: 'France',
  countryCode: 'FR',
};
